import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSort,
    faSortAsc,
    faSortDesc,
} from "@fortawesome/free-solid-svg-icons";

import styles from "components/ReactTable/Components/THeadContent/THeadContent.module.css";

export default function THeadContent({ headerGroups }) {
    // react-table's prop getters include `key`; React warns when a key arrives through a spread.
    return headerGroups.map((headerGroup) => {
        const { key: rowKey, ...headerGroupProps } =
            headerGroup.getHeaderGroupProps();
        return (
            <tr key={rowKey} {...headerGroupProps}>
                {headerGroup.headers.map((column) => {
                    const { key: headerKey, ...headerProps } =
                        column.getHeaderProps();
                    return (
                        <th
                            key={headerKey}
                            {...headerProps}
                            // Don't let clicking the entire header trigger a sort
                            onClick={(e) => e.stopPropagation()}
                            className={styles.tableHeader}
                        >
                            {
                                // Render the header
                                column.render("Header")
                            }
                            {/* Sorting Status Icons */}
                            <span
                                // Toggle the sort here on the sort icon instead of by clicking the header
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (column.canSort) column.toggleSortBy();
                                }}
                            >
                                {/* Sorting Status Icons  */}
                                {column.canSort &&
                                    (column.isSorted ? (
                                        column.isSortedDesc ? (
                                            <FontAwesomeIcon
                                                className={styles.sorted}
                                                icon={faSortDesc}
                                            />
                                        ) : (
                                            <FontAwesomeIcon
                                                className={styles.sorted}
                                                icon={faSortAsc}
                                            />
                                        )
                                    ) : (
                                        <FontAwesomeIcon
                                            className={styles.sortIcon}
                                            icon={faSort}
                                        />
                                    ))}
                            </span>
                            {/* Column filters */}
                            <div>
                                {column.canFilter ? (
                                    column.render("Filter")
                                ) : (
                                    <div
                                        style={{
                                            height: "27px",
                                        }}
                                    />
                                )}
                            </div>
                        </th>
                    );
                })}
            </tr>
        );
    });
}
